import { Button, ETextStyleVariant, Text } from '@outdoorsyco/bonfire';
import NextLink from 'next/link';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

export const ClaimThisPage = () => {
  const intl = useIntl();

  return (
    <div className="flex flex-col px-10 rounded-lg md:items-center md:flex-row md:justify-between py-7 bg-canvas-100 gap-10 md:gap-2">
      <div>
        <Text variant={ETextStyleVariant.LargeBold}>
          <FormattedMessage
            defaultMessage="Outdoorsy uses public information to populate this page."
            id="xWvd21"
          />
        </Text>

        <Text variant={ETextStyleVariant.MediumRegular} className="mt-2">
          <FormattedMessage
            defaultMessage="Campground hosts can claim this page to customize and keep this information up to date."
            id="6gQcl4"
          />
        </Text>
      </div>

      <NextLink href="/become-a-host/campground" passHref legacyBehavior>
        <Button
          label={intl.formatMessage({ defaultMessage: 'Claim this page', id: '4obLf1' })}
          className="w-full md:w-auto md:whitespace-nowrap"
        />
      </NextLink>
    </div>
  );
};
